import { Link } from 'react-router-dom';
import { SITE_NAME } from '../constants/site';
import { CONTACT } from '../constants/contact';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="dh-footer">
      <div className="dh-container dh-footer__grid">
        <div>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms Of Service</Link></li>
            <li><Link to="/refund-policy">Refund and Returns Policy</Link></li>
          </ul>
        </div>
        <div>
          <h3>Contact</h3>
          <ul>
            <li><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            <li>{CONTACT.company}</li>
            <li>{CONTACT.addressLine1}</li>
            <li>{CONTACT.addressLine2}</li>
          </ul>
        </div>
      </div>
      <div className="dh-footer__bottom">
        <p>
          Copyright © {new Date().getFullYear()} {SITE_NAME}. All Rights Reserved. Operated by{' '}
          {CONTACT.company}.
        </p>
      </div>
    </footer>
  );
}
